import { render, staticRenderFns } from "./LiquidButton.vue?vue&type=template&id=16560b98&"
import script from "./LiquidButton.vue?vue&type=script&lang=ts&"
export * from "./LiquidButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports